/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import useDebounce from 'modules/common/components/UseDebounce';
import * as actions from '../action';
import * as c from '../constant';
import SMSNotificationsContent from './SMSNotificationsContent';

const form = {
  keyword: '',
};

function SMSNotificationsContainer({
  getTransactionList,
  transactionList,
  transactionListPager,
  match,
  isLoading,
  history,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);

  const UpdateData = () => {
    getTransactionList();
    return () => {
      setModal({ isOpen: false });
    };
  };

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
  };

  const handleOnChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm) {
      getTransactionList({
        q: formData.keyword,
      });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="SMS Notifications"
            getData={getTransactionList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search by Mobile Number..."
            pathName={`${match.path}/:id?`}
            listName="Transaction"
            label="SMS Notifications List"
            renderItem={item => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {`${_.get(item, 'attributes.mobile_number')}`}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {_.get(item, 'attributes.status')}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            selected={params.id}
            data={transactionList}
            dataPager={transactionListPager}
            handleSelectRow={data => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => <SMSNotificationsContent UpdateData={UpdateData} />}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.business_Id && transactionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(transactionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

SMSNotificationsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
  transactionListPager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION}.list`) || [],
  transactionListPager: _.get(api, `${c.GET_TRANSACTION}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SMSNotificationsContainer);
